import {
  useCallback,
  useMemo,
  useState,
  createContext,
  useContext,
  PropsWithChildren,
  SetStateAction,
  Dispatch,
} from 'react'

import { useMedia } from '@/hooks/useMedia'

interface MenuContextValue {
  isMenuOpen: boolean
  isMobile: boolean
  setIsMenuOpen: Dispatch<SetStateAction<boolean>>
  toggleIsMenuOpen: () => void
}

const MenuContext = createContext<MenuContextValue | undefined>(undefined)

export const MenuProvider = ({ children }: PropsWithChildren) => {
  const isMobile = useMedia(['(max-width: 768px)'], [true], false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleIsMenuOpen = useCallback(
    () => setIsMenuOpen(!isMenuOpen),
    [isMenuOpen]
  )

  const value = useMemo(
    () => ({
      isMenuOpen,
      isMobile,
      setIsMenuOpen,
      toggleIsMenuOpen,
    }),
    [isMenuOpen, isMobile, setIsMenuOpen, toggleIsMenuOpen]
  )

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>
}

export const useMenuContext = () => {
  const context = useContext(MenuContext)
  if (context === undefined) {
    throw new Error('useMenuContext must be used within a MenuProvider')
  }
  return context
}
